<div class="table-responsive" [class.overflow-hidden]="emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover directory-list-table footable">
        <thead>
            <tr [ngClass]="{'noSort': data.length < 2}">
                <th (click)="orderBy('createdAt', $event)" class="footable-sorted">
                    Date<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('suiteUser.user.fullName', $event)">
                    Resident<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="directoryService.buildings.length != 1 && !directoryService.showDetailedView"
                    (click)="orderBy('suite.building.name', $event)">
                    Building<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('suite.suiteNumber', $event)">
                    Unit<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!directoryService.showDetailedView">Modified</th>
                <th>Type</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data">
                <td>{{item.createdAt | mccDate : false : true }}</td>
                <td>
                    <span *ngIf="item.action === 'create'">{{ item.userProfile?.fullName }}</span>
                    <span *ngIf="item.action !== 'create'">{{item.suiteUser?.user.fullName}}</span>
                </td>
                <td *ngIf="directoryService.buildings.length != 1">
                    {{item.suite.building.name}}
                </td>
                <td>{{item.suite.suiteNumber}}</td>
                <td>{{getPatchDescription(item)}}</td>
                <td>
                    <span title="{{actionTitles[item.action] || item.action}}" class="label {{item.action}}-label">
                        {{actionTitles[item.action] || item.action}}
                    </span>
                </td>
                <td class="td-action-btn">
                    <div class="input-group-btn btn-in-table input-group" *ngIf="item.isCanEdit">
                        <button (click)="openApprovalModal(item)" class="btn btn-white btn-xs">Review</button>
                    </div>
                </td>
            </tr>
            <tr *ngFor="let item of emptyRowService.emptyRow" style="cursor: default;">
                <td>&nbsp;</td>
                <td></td>
                <td *ngIf="directoryService.buildings.length != 1"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message
            [isEmpty]="!directoryService.directoryData['updates'].total"
            [isServiceUnavailable]="directoryService.showServiceUnavailable"
            [isLoading]="directoryService.spinnerShow">
        You have no updates
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/updates-list/updates-list.component.html